<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Medewerker bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditEmployeeDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-2 pa-2" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="EditEmployeeForm" lazy-validation>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field
                label="Voornaam"
                v-model="selectedEmployeeItem.firstName"
                prepend-inner-icon="person"
                required
                outlined
                hide-details
                :color="companyPrimaryColor"
                class="mt-4"
                :background-color="$vuetify.theme.themes[theme].menu"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md6>
              <v-text-field
                label="Achternaam"
                v-model="selectedEmployeeItem.lastName"
                prepend-inner-icon="person"
                required
                outlined
                hide-details
                :color="companyPrimaryColor"
                class="mt-4"
                :background-color="$vuetify.theme.themes[theme].menu"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md6>
              <v-menu
                ref="birtdayDateDialog"
                :close-on-content-click="false"
                v-model="birtdayDateDialog"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="birthdayDate.readable"
                    label="Geboortedatum"
                    prepend-inner-icon="cake"
                    readonly
                    outlined
                    hide-details
                    :color="companyPrimaryColor"
                    class="mt-4"
                    :background-color="$vuetify.theme.themes[theme].menu"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="birthdayDateRaw"
                  no-title
                  :max="today"
                  color="primary"
                  @input="birtdayDateDialog = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-select
                :items="branches"
                item-text="branchName"
                item-value="id"
                prepend-inner-icon="location_on"
                v-model="selectedEmployeeItem.branches"
                label="Vestigingen"
                outlined
                multiple
                hide-details
                :color="companyPrimaryColor"
                class="mt-4"
                :background-color="$vuetify.theme.themes[theme].menu"
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md6>
              <v-select
                :items="positions"
                item-text="name"
                item-value="id"
                prepend-inner-icon="assignment"
                v-model="selectedEmployeeItem.position"
                label="Functie"
                outlined
                hide-details
                :color="companyPrimaryColor"
                class="mt-4"
                :background-color="$vuetify.theme.themes[theme].menu"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-menu
                :close-on-content-click="false"
                v-model="functionStartDateDialog"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="functionStartDate.readable"
                    label="Startdatum functie"
                    prepend-inner-icon="today"
                    readonly
                    clearable
                    outlined
                    @click:clear="clearContractStartDate()"
                    hide-details
                    :color="companyPrimaryColor"
                    class="mt-4"
                    :background-color="$vuetify.theme.themes[theme].menu"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="functionStartDateRaw"
                  no-title
                  color="primary"
                  @input="functionStartDateDialog = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md6>
              <v-menu
                :close-on-content-click="false"
                v-model="functionEndDateDialog"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="functionEndDate.readable"
                    label="Einddatum functie"
                    clearable
                    prepend-inner-icon="today"
                    readonly
                    @click:clear="clearContractEndDate()"
                    outlined
                    hide-details
                    :color="companyPrimaryColor"
                    class="mt-4"
                    :background-color="$vuetify.theme.themes[theme].menu"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="functionEndDateRaw"
                  no-title
                  color="primary"
                  @input="functionEndDateDialog = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditEmployeeDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed || busy"
              :depressed="!changed || busy"
              :dark="changed || busy"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="updateEmployee()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import moment from "moment";

export default {
  name: "edit-employee-form",
  props: {
    activeCompData: Object,
    positions: Array,
    branches: Array,
    selectedEmployeeItem: Object,
    selectedEmployeeItemOriginal: Object,
  },

  data() {
    return {
      feedback: null,
      birtdayDateDialog: false,
      functionEndDateDialog: false,
      functionStartDateDialog: false,
      today: null,
      birthdayDateRaw: null,
      functionStartDateRaw: null,
      functionEndDateRaw: null,
      busy: false,
    };
  },

  created() {
    this.today = moment().format("YYYY-MM-DD");
  },

  methods: {
    closeEditEmployeeDialog() {
      this.$emit("editEmployeeDialogChange", false);
      this.functionStartDateRaw = null;
      this.functionEndDateRaw = null;
      this.birthdayDateRaw = null;
    },

    clearContractStartDate() {
      this.functionStartDateRaw = null;
    },

    clearContractEndDate() {
      this.functionEndDateRaw = null;
    },

    updateEmployee() {
      if (
        this.selectedEmployeeItem.firstName &&
        this.selectedEmployeeItem.lastName &&
        this.selectedEmployeeItem.position
      ) {
        this.feedback = null;
        this.busy = true;

        let basicSchedule = _.cloneDeep(
          this.selectedEmployeeItem.basicSchedule,
        );
        this.selectedEmployeeItem.branches.forEach((branch) => {
          if (!basicSchedule[branch]) {
            basicSchedule[branch] = {};
            basicSchedule[branch].startDate = null;
            basicSchedule[branch].endDate = null;
            basicSchedule[branch].basicScheduleLastChanged = null;
            basicSchedule[branch].sun = [];
            basicSchedule[branch].mon = [];
            basicSchedule[branch].tue = [];
            basicSchedule[branch].wed = [];
            basicSchedule[branch].thu = [];
            basicSchedule[branch].fri = [];
            basicSchedule[branch].sat = [];
          }
        });

        db.collection("employees")
          .doc(this.selectedEmployeeItem.id)
          .set(
            {
              firstName: this.selectedEmployeeItem.firstName,
              lastName: this.selectedEmployeeItem.lastName,
              position: this.selectedEmployeeItem.position,
              basicSchedule: basicSchedule,
              branches: this.selectedEmployeeItem.branches,
              birthdayDate: this.birthdayDate.firebase,
              startFunctionDate: this.functionStartDate.firebase,
              endFunctionDate: this.functionEndDate.firebase,
            },
            { merge: true },
          )
          .then(() => {
            this.busy = true;
            this.$emit("updateData");
            this.closeEditEmployeeDialog();
            this.$refs.EditEmployeeForm.reset();
          })
          .catch((error) => {
            console.error("Error adding position: ", error);
            this.busy = true;
          });
      } else {
        this.feedback = "Vul alle velden in om de wijzigingen op te slaan";
      }
    },
  },

  computed: {
    birthdayDate() {
      let date = {
        readable: "",
        formatted: "",
        firebase: null,
      };
      if (this.birthdayDateRaw) {
        date.readable = moment(this.birthdayDateRaw).format("D-M-YYYY");
        date.formatted = moment(this.birthdayDateRaw).format("YYYY/MM/DD");
        date.firebase = new Date(
          moment(this.birthdayDateRaw).format("YYYY/MM/DD"),
        );
        return date;
      } else if (this.selectedEmployeeItem.birthdayDateRaw) {
        date.readable = moment(
          this.selectedEmployeeItem.birthdayDateRaw,
        ).format("D-M-YYYY");
        date.formatted = moment(
          this.selectedEmployeeItem.birthdayDateRaw,
        ).format("YYYY/MM/DD");
        date.firebase = new Date(
          moment(this.selectedEmployeeItem.birthdayDateRaw).format(
            "YYYY/MM/DD",
          ),
        );
        return date;
      } else {
        return date;
      }
    },
    functionStartDate() {
      let date = {
        readable: "",
        formatted: "",
        firebase: null,
      };
      if (this.functionStartDateRaw) {
        date.readable = moment(this.functionStartDateRaw).format("D-M-YYYY");
        date.formatted = moment(this.functionStartDateRaw).format("YYYY/MM/DD");
        date.firebase = new Date(
          moment(this.functionStartDateRaw).format("YYYY/MM/DD"),
        );
        return date;
      } else if (this.selectedEmployeeItem.functionStartDateRaw) {
        date.readable = moment(
          this.selectedEmployeeItem.functionStartDateRaw,
        ).format("D-M-YYYY");
        date.formatted = moment(
          this.selectedEmployeeItem.functionStartDateRaw,
        ).format("YYYY/MM/DD");
        date.firebase = new Date(
          moment(this.selectedEmployeeItem.functionStartDateRaw).format(
            "YYYY/MM/DD",
          ),
        );
        return date;
      } else {
        return date;
      }
    },
    functionEndDate() {
      let date = {
        readable: "",
        formatted: "",
        firebase: null,
      };
      if (this.functionEndDateRaw) {
        date.readable = moment(this.functionEndDateRaw).format("D-M-YYYY");
        date.formatted = moment(this.functionEndDateRaw).format("YYYY/MM/DD");
        date.firebase = new Date(
          moment(this.functionEndDateRaw).format("YYYY/MM/DD"),
        );
        return date;
      } else if (this.selectedEmployeeItem.functionEndDateRaw) {
        date.readable = moment(
          this.selectedEmployeeItem.functionEndDateRaw,
        ).format("D-M-YYYY");
        date.formatted = moment(
          this.selectedEmployeeItem.functionEndDateRaw,
        ).format("YYYY/MM/DD");
        date.firebase = new Date(
          moment(this.selectedEmployeeItem.functionEndDateRaw).format(
            "YYYY/MM/DD",
          ),
        );
        return date;
      } else {
        return date;
      }
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    changed() {
      if (
        _.isEqual(
          this.selectedEmployeeItem,
          this.selectedEmployeeItemOriginal,
        ) == false ||
        this.functionStartDateRaw ||
        (!this.functionStartDate.readable &&
          this.selectedEmployeeItemOriginal.functionStartDateRaw) ||
        (!this.functionEndDate.readable &&
          this.selectedEmployeeItemOriginal.functionEndDateRaw) ||
        this.functionEndDateRaw ||
        this.birthdayDateRaw
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
